<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
        <div class="fixed-top-menu">
          <div class="pull-right">
            <ajaxLoaderButton :onClick="save" iconclass="fa fa-save" label="Ment" v-model="is_save"/>
          </div>
        </div>
      </div>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Kezdőőoldal</li>
            <li>Felhasználók</li>
            <li>Felhasználó</li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Felhasználó</h1>
          </div>
          <div class="content-panel-top-btn-group">
            <ajaxLoaderButton :onClick="save" iconclass="fa fa-save" label="Ment" v-model="is_save"/>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Felhasználó</h4>
            </div>
            <form>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-6">
                  <div class="panel-sub-heading"><h4>Adatok</h4></div>
                    <select2ajax url="shibuser/search" :change="shibUserChange" id="dn" label="Címtár felhasználó" v-bind:errors="errors" name="dn" v-model="form.shib_users"></select2ajax>
                    <inputbox id="username" label="Felhasználónév" v-bind:errors="errors" name="username" v-model="form.user.username"></inputbox>
                    <inputbox id="email" label="Email" v-bind:errors="errors" name="email" v-model="form.user.email"></inputbox>
                    <inputbox inputCheck="name" id="fullname" label="Név" v-bind:errors="errors" name="fullname" v-model="form.user.fullname"></inputbox>
                    <inputbox id="password" label="Jelszó" v-bind:errors="errors" name="password" v-model="form.user.password"></inputbox>
                    <inputbox id="password_" label="Jelszó újra" v-bind:errors="errors" name="password_" v-model="form.user.password_"></inputbox>
                    <combobox :change="groupChange" id="group_id" label="Csoport" v-bind:errors="errors" name="group_id" v-model="form.user_groups"></combobox>
                    <select2 multi="true" id="card_types" label="Kezelhető kártyatípusok" v-bind:errors="errors" name="card_types" v-model="form.card_types"></select2>
                </div>
                <div class="col-xs-6">
                  <div class="panel-sub-heading"><h4>Jogosultságok</h4></div>
                  <ulRule rootClass="tree" v-bind:rules="form.rules"/>
                </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
import Vue from 'vue';

import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

Vue.component('ulRule', {
  props: ['rules','rootClass'],
  template: '<ul v-bind:class="rootClass">\
<li v-for="rule in rules">\
  <div>\
    <span v-on:click="expandClick(rule)" class="expand-icon"><i v-if="rule.childs" v-bind:class="toggleClass(rule)"></i></span>\
    <span class="icon"><i class="fa fa-folder"></i></span>\
    <div v-on:click="ruleClick(rule)" class="checkbox">\
      <input type="checkbox" v-bind:id="rule.id" v-bind:name="rule.id" v-bind:value="rule.id" v-model="rule.selected">\
      <label v-bind:for="rule.id"></label>\
    </div>\
    {{ rule.title }}\
    <ulRule v-show="rule.open" v-if="rule.childs" v-bind:rules="rule.childs"/>\
  </div>\
</li>\
</ul>',
  methods: {
    expandClick: function(rule) {
      rule.open = !rule.open;
    },

    toggleClass: function(rule) {
      return rule.open ? 'fa fa-minus' : 'fa fa-plus';
    },

    setRuleChilds: function(rule, selected) {
      var _this = this;

      if (rule.childs == undefined || rule.childs.length == 0)
        return;

      rule.childs.map(function(rule_child) {
        rule_child.selected = selected;
        _this.setRuleChilds(rule_child, selected);
      });
    },

    ruleClick: function(rule) {
      this.setRuleChilds(rule, rule.selected);
    }
  }
});

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      form: {
        user: {},
        user_groups: {},
        rules: [],
        shib_users: {
          items: [],
          selected : null
        },
        card_types: {
          items: [],
          selected: []
        },
      },
      errors: [],
      is_save: false
    }
  },
  mounted: function() {
    var _this = this;

    this.$root.ajax('user/edit/' + (this.$route.query.userID != undefined ? this.$route.query.userID : 0), {
      success: function(response) {
        response.user.password_ = response.user.password;
        _this.form.user = response.user;
        _this.form.user_groups = response.user_groups;
        _this.form.card_types = response.card_types;
        _this.form.rules = response.rules;
        _this.form.shib_users = response.shib_users;
      }
    });
  },
  methods: {
    groupChange: function() {
      var _this = this;

      this.$root.ajax('user/grouprules/' + this.form.user_groups.selected, {
        success: function(response) {
          _this.form.rules = response.rules;
        }
      });
    },

    shibUserChange: function() {
      var _this = this;

      this.$root.ajax('user/getShibUser/' + this.form.shib_users.selected + '/mid', {
        success: function(response) {
          _this.form.user = response.user;
        }
      });
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      form.card_types = form.card_types.selected;
      form.shib_users = form.shib_users.selected;

      this.$root.ajax('user/save', {
        method: 'POST',
        data: form,
        success: function(response) {
          _this.is_save = false;
          
          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            _this.$router.push({path: '/users/list'});
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// user.vue?3a697280